import type { ColDef } from "ag-grid-enterprise";
import { MONTHLY_KEYS } from "../../../../utils/timePeriodUtils";
import type { CalendarType, TimePeriodColumnOptions } from "../columnFactory";
import { baseTimePeriodProperties } from "./baseTimePeriodProperties";
import { getEditableByPlanBy } from "./editableByPlanBy";

/**
 * Creates the 12 monthly column definitions (M01–M12).
 * Monthly columns are only editable for the inventory_454 calendar type.
 */
export function createMonthlyColumns(
  calendarType: CalendarType,
  options: TimePeriodColumnOptions
): ColDef[] {
  const {
    planBy,
    planningYear,
    metaData,
    intake,
    editableProducer,
    editableRowPredicate,
    editableMetricsOverride,
    editableTimeWindowPredicate,
    cubeWindow
  } = options;
  const base = baseTimePeriodProperties(
    planBy,
    planningYear,
    metaData,
    cubeWindow,
    editableTimeWindowPredicate !== undefined
  );
  const editable =
    planBy === "SH%" || calendarType !== "inventory_454"
      ? false
      : getEditableByPlanBy({
          planBy,
          planningYear,
          metaData,
          intake,
          editableProducer,
          editableRowPredicate,
          editableMetricsOverride,
          editableTimeWindowPredicate,
          cubeWindow
        });

  // gregMapping translates fiscal months (M01=Aug); the gregorian view's
  // M01 already is January, so its labels come from gregHeaders instead.
  const monthLabels =
    calendarType === "gregorian" ? metaData.gregHeaders : metaData.gregMapping;

  return MONTHLY_KEYS.map((fieldId) => ({
    ...base,
    field: fieldId,
    headerName: monthLabels[fieldId] ?? fieldId,
    headerTooltip: fieldId,
    editable
  }));
}
